import { DumpsterSize, DumpWeightByMaterial, MaterialWeights } from "../../../models";

// Wire shape of the `dump_weight_by_material` setting value. Weights are
// serialized by the backend's shopspring/decimal as JSON strings (e.g. "1.5").
export type RawDumpWeightByMaterial = Record<string, Record<string, string>>;

export function getDumpWeightByMaterial(
  raw: RawDumpWeightByMaterial
): DumpWeightByMaterial {
  const out = {} as DumpWeightByMaterial;
  for (const size of Object.keys(raw)) {
    const weights: MaterialWeights = {};
    const byMaterial = raw[size];
    for (const material of Object.keys(byMaterial)) {
      weights[material] = parseFloat(byMaterial[material]);
    }
    out[size as DumpsterSize] = weights;
  }
  return out;
}
